import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import HsStatusPage from 'src/components/common/hs/HsStatusPage';
import useDocumentTitle from 'src/hooks/common/document-title';
import NotFoundPage from 'src/pages/common/NotFoundPage';

/** 배포로 화면 코드 파일 이름이 바뀌어 옛 파일을 못 받는 경우(새로고침하면 낫는다) */
function isStaleChunk(error: unknown) {
  return (
    error instanceof Error && /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module/i.test(error.message)
  );
}

/** 화면을 그리다 난 오류. 새로고침을 권하고, 자세한 내용은 접어 둔다 */
export default function RouteErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();
  useDocumentTitle(t('hs.error'));

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  const detail = error instanceof Error ? error.stack || error.message : JSON.stringify(error, null, 2);

  return (
    <HsStatusPage
      icon="fa-solid fa-triangle-exclamation"
      title={t('hs.crash-title')}
      description={isStaleChunk(error) ? t('hs.crash-update') : t('hs.crash-desc')}
    >
      <button type="button" className="hs-btn primary" onClick={() => window.location.reload()}>
        <i className="fa-solid fa-rotate-right" />
        {t('hs.reload')}
      </button>
      <a className="hs-btn" href="/">
        <i className="fa-solid fa-house" />
        {t('hs.go-home')}
      </a>
      {detail && (
        <details className="hs-status-detail">
          <summary>{t('hs.crash-detail')}</summary>
          <pre className="hs-code">{detail}</pre>
        </details>
      )}
    </HsStatusPage>
  );
}
